import { useAuth } from './hooks/useAuth'
import Login from './pages/Login'

function App() {
  const { user, userRole, loading } = useAuth()

  if (loading) return (
    <div style={{
      minHeight: '100vh', background: '#0F1117',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: '#4ADE80', fontFamily: 'DM Sans, sans-serif', fontSize: 14
    }}>
      Cargando...
    </div>
  )

  if (!user || !userRole) return <Login />

  if (userRole === 'paciente') {
    const PatientApp = require('./pages/patient/PatientApp').default
    return <PatientApp />
  }

  if (userRole === 'profesional' || userRole === 'admin') {
    const ProApp = require('./pages/pro/ProApp').default
    return <ProApp />
  }

  return <Login />
}

export default App